gsap.registerPlugin(ScrollTrigger);
const tl = gsap.timeline();

// auto scroll image section
window.addEventListener('load', function () {
  if (window.innerWidth >= 768) {
    const races = document.querySelector(".auto_scroll_main");
    const progressBar = document.querySelector('.progress_inner');
    const containerWidth = document.querySelector('.progress-main').offsetWidth;

    function getScrollAmount() {
      let racesWidth = races.scrollWidth;
      return -(racesWidth - window.innerWidth);
    }
    const timeline = gsap.timeline();

    timeline.to(races, {
      x: getScrollAmount,
      ease: "none"
    });

    timeline.to('.progress_inner', {
      x: () => {
        return containerWidth - (195)
      },
      ease: "none"
    }, 0)

    ScrollTrigger.create({
      trigger: ".coll_pin_section",
      start: "top top",
      end: () => `+=${getScrollAmount() * -1}`,
      pin: true,
      animation: timeline,
      scrub: true,
      invalidateOnRefresh: true,
    });

    ScrollTrigger.observe({
      target: ".auto_scroll_container",
      type: "pointer,touch",

      onDrag: (self) => {
        gsap.to(window, {
          scrollTo: {
            y: `+=${self.deltaX * 10}`
          }
        });
      }
    });

    ScrollTrigger.addEventListener("refreshInit", getScrollAmount);
  }
});
